/**
 * Zod schema for the `Branch` persistence shape.
 *
 * Mirrors `../types/branch.ts`. Spec authority: `architecture.md §4.7`
 * `CREATE TABLE branches`.
 */

import { z } from "zod";
import type { Branch, BranchStatus } from "../types/branch.js";
import { UUID_RE, HANDLE_SLUG_RE } from "../urls/types.js";

const uuid = z.string().regex(UUID_RE);
const slug = z.string().regex(HANDLE_SLUG_RE);
const timestamp = z.number().int().nonnegative();

export const BranchStatusSchema: z.ZodType<BranchStatus> = z.enum(["active", "merged", "archived"]);

export const BranchSchema = z
  .object({
    uuid,
    recipeUuid: uuid,
    slug,
    parentBranchUuid: uuid.nullable().optional(),
    parentCommitUuid: uuid.nullable().optional(),
    headCommitUuid: uuid.nullable().optional(),
    status: BranchStatusSchema,
    ephemeral: z.boolean(),
    authorAgent: z.string(),
    createdAt: timestamp,
    updatedAt: timestamp,
  })
  .strict();

type _Assert =
  z.infer<typeof BranchSchema> extends Branch
    ? Branch extends z.infer<typeof BranchSchema>
      ? true
      : never
    : never;
export type __BranchSchemaAssert = _Assert;
